import { useTranslation } from "react-i18next";

import { Typography } from "../typography";

import classes from "./styles.module.scss";

import type { ISubtitleProps, ISubtitleVariantProps } from ".";

import { Icon } from "@components/atoms/icons";

export function Subtitle(props: ISubtitleProps & ISubtitleVariantProps) {
  const { title, variant, ...rest } = props;
  const { t } = useTranslation("subtitle");

  return (
    <div className={classes.subtitle}>
      {variant === "withIcon" && props.iconName && (
        <Icon name={props.iconName} fontSize={"2xl"} color={"primary-main"} />
      )}
      <Typography
        variant={variant === "withIcon" ? "h4" : "formSectionHeader"}
        {...rest}
      >
        {`${t(title)}:`}
      </Typography>
    </div>
  );
}
